import React from 'react'
import ReactModal from 'react-modal'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const openTimeInSeconds = 0.425
const closeTimeInSeconds = 0.3

const overlayClasses: ReactModal.Classes = {
  base: css`
    z-index: 1002;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: block;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color ${openTimeInSeconds}s linear;
  `,
  afterOpen: css`
    overflow-y: auto;
    overflow-x: hidden;
    background-color: ${theme.color.neutral10};
  `,
  beforeClose: css`
    transition: background-color ${closeTimeInSeconds}s linear;
    background-color: rgba(0, 0, 0, 0);
  `
}

const contentClasses: ReactModal.Classes = {
  base: css`
    position: relative;
    outline: none;
    transition: opacity ${openTimeInSeconds}s ease-out;
    opacity: 0;
    pointer-events: none;

    > * {
      margin-bottom: 150px;
    }
  `,
  afterOpen: css`
    opacity: 1;
  `,
  beforeClose: css`
    transition: opacity ${closeTimeInSeconds}s ease-out;
    opacity: 0;
  `
}

const styledProps = {
  overlayClassName: overlayClasses,
  className: contentClasses,
  closeTimeoutMS: closeTimeInSeconds * 1000
}

interface Props {
  readonly children: React.ReactNode
  readonly isOpen: boolean
  readonly shouldCloseOnEsc?: boolean
}

export function FullscreenDialog({
  children,
  isOpen = false,
  shouldCloseOnEsc = false,
  ...props
}: Props) {
  return (
    <ReactModal
      {...styledProps}
      ariaHideApp={false}
      isOpen={isOpen}
      shouldCloseOnEsc={shouldCloseOnEsc}
      data-testid={props['data-testid']}
    >
      <div
        className={css`
          display: flex;
          flex-direction: column;
          pointer-events: auto;
          margin: 0;
        `}
      >
        {children}
      </div>
    </ReactModal>
  )
}
